module.exports = __webpack_public_path__ + "static/media/sharecard-slide-select.47c2dc62.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sharecard-slide-select.png
// module id = 2064
// module chunks = 6